/** Client-facing company label: drop a trailing "Control Bridge" so the page title is not repeated. */
export function cbDisplayCompanyTitle(title: string | undefined): string {
  const t = (title ?? '').trim();
  if (!t) return 'Company';
  const stripped = t.replace(/\s+Control Bridge$/i, '').trim();
  return stripped || t;
}
